import { EnumerationItem } from "projects/shared/models/enumeration-item.model";
import { Borrower } from "./borrower-model";
import { CustomData } from "./custom-data.model";
import { PortalGlobalConfig } from "./global-config.model";
import { LoanApplication } from "./loan-info.model";
import { PortalContent } from "./borrower-portal/portal-content-model-model";
import { UrlaMortgage } from "./urla-mortgage.model";
import { UserData } from "./user/user-data.model";
import { UserPermissions } from "./user/user-permissions.model";
import { UserType } from "./user/user-type.enum";

export class ApplicationContext {
  currentlyLoggedInUser: UserData;
  application: LoanApplication;
  customData: CustomData;
  currentMortgage: UrlaMortgage;
  borrowers: Borrower[] = [];
  globalConfig: PortalGlobalConfig;
  mortgageEnums: any;
  pricingEnums: any;
  userPermissions: Pick<UserPermissions, 'userId' | 'companyId'>;
  portalContent: PortalContent;
  mergeFields: EnumerationItem[];
  industryAffiliations: string[] = [];

  isCallControlPanelOpen: boolean = false;

  get isTpo(): boolean {
    return this.currentlyLoggedInUser.userType === UserType.Tpo;
  }

  get isCompanyPHM(): boolean {
    return [252].includes(this.userPermissions.companyId);
  }

  get companyName(): string {
    return this.portalContent?.companyName || '';
  }
}
